import { useCallback } from 'react';

import { useTrackScreen } from '@order/Telemetry';

import { useSnapPixel } from '../../../../integrations';
import { type RouteInfo, useRouteObserver } from '../useRouteObserver';
import { trackDatadogView } from './utils';

// ─────────────────────────────────────────────────────────────────────────────

export const useTrackRoutes = () => {
  const { trackScreen } = useTrackScreen();
  const { trackPageView: trackSnapPixelPageView } = useSnapPixel();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handleRouteChange = useCallback(
    (route: RouteInfo) => {
      trackScreen(route.pathname);
      trackSnapPixelPageView({ description: route.pathname });
      trackDatadogView(route.viewKey, route.pathname);
    },
    [trackScreen, trackSnapPixelPageView],
  );

  // ─────────────────────────────────────────────────────────────────────

  useRouteObserver({ onChange: handleRouteChange });
};
